import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPromoIpProtection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3L4 7v5c0 4.418 3.582 8.536 8 9.5 4.418-.964 8-5.082 8-9.5V7L12 3z",
		stroke: "#2917D6",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgPromoIpProtection;
